module.exports = __webpack_public_path__ + "img/csm_expovina_03_web_0dc2065b68.ba4ab0ec.jpg";